import { useEffect, useState } from "react";

const defaultEvents = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll"
];

/**
 * Returns true if none of the `events` triggered during `delay` indicating
 * the user is inactive/idle
 * @param {Number} delay
 * @param {String[]} [events=defaultEvents]
 * @returns {Boolean} idle
 */
const useIdle = (delay, events = defaultEvents) => {
  const [idle, setIdle] = useState(false);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setIdle(true);
    }, delay);

    return () => clearTimeout(id);
  }, [delay, reset]);

  useEffect(() => {
    function handleEvent() {
      setIdle(false);
      setReset(reset => !reset);
    }
    addEventListeners(events, handleEvent);
    return () => removeEventListeners(events, handleEvent);
  }, [events]);

  return idle;
};

function addEventListeners(events, handler) {
  for (const event of events) {
    window.addEventListener(event, handler, true);
  }
}

function removeEventListeners(events, handler) {
  for (const event of events) {
    window.removeEventListener(event, handler, true);
  }
}

export default useIdle;
